import { motion } from "framer-motion";
import { SectionHeading, reveal } from "./SectionHeading";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1477516561410-f0b5dd8319e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxzcG9va3klMjBoYWxsb3dlZW4lMjBwdW1wa2luJTIwZ2xvd2luZ3xlbnwwfHx8fDE3OTE4OTcxNDd8MA&ixlib=rb-4.1.0&q=85";

export default function Lore() {
  return (
    <section id="lore" data-testid="lore-section" className="relative px-6 py-28 sm:px-12 sm:py-36">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Chapter I // The Lore"
          title="The Curse of"
          accent="Green Candles"
          description="Every October, traders feel the bone-chilling shiver of missed multipliers. FOMOWEEN was summoned from that seasonal panic."
          testid="lore-heading"
        />

        <div className="grid grid-cols-12 gap-6">
          <motion.article
            data-testid="lore-card-main"
            {...reveal(0)}
            className="crypt-card col-span-12 flex min-h-[22rem] flex-col justify-end lg:col-span-8"
          >
            <img
              src={ABOUT_IMG}
              alt="Dual glowing jack-o'-lanterns sitting in eerie darkness"
              className="absolute inset-0 h-full w-full object-cover opacity-60"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-abyss via-abyss/70 to-transparent" />
            <div className="relative">
              <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-orange-400/80">
                Lore Chapter I
              </span>
              <h3 className="mt-3 font-syne text-xl font-extrabold uppercase tracking-tight text-zinc-100 sm:text-2xl">
                Why FOMOWEEN Dominates the Crypt
              </h3>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-zinc-300 sm:text-base">
                FOMOWEEN was born from the collective nightmares of selling too
                early on the FOMO app. We turned seasonal panic into
                high-velocity liquidity — a coin that only wakes when the veil
                is thinnest.
              </p>
            </div>
          </motion.article>

          <motion.article
            data-testid="lore-card-synergy"
            {...reveal(0.1)}
            className="crypt-card col-span-12 sm:col-span-6 lg:col-span-4"
          >
            <p className="font-cinzel text-4xl font-black text-pumpkin sm:text-5xl">100%</p>
            <p className="mt-2 font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-orange-400/80">
              Degen Focused
            </p>
            <h3 className="mt-5 font-syne text-lg font-extrabold uppercase tracking-tight text-zinc-100">
              The FOMO App Synergy
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              Engineered around the high-speed trading culture of the FOMO
              memecoin terminal. Instant snipes, zero latency, maximum
              adrenaline.
            </p>
          </motion.article>

          <motion.article
            data-testid="lore-card-taxes"
            {...reveal(0.15)}
            className="crypt-card col-span-12 sm:col-span-6 lg:col-span-4"
          >
            <p className="font-cinzel text-4xl font-black text-ecto sm:text-5xl">0/0</p>
            <p className="mt-2 font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-orange-400/80">
              Buy / Sell Tax
            </p>
            <h3 className="mt-5 font-syne text-lg font-extrabold uppercase tracking-tight text-zinc-100">
              Zero Witch Taxes
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              No dev tithes, no hidden coffins. What enters your wallet stays
              in your wallet.
            </p>
          </motion.article>

          <motion.article
            data-testid="lore-card-security"
            {...reveal(0.2)}
            className="crypt-card col-span-12 lg:col-span-8"
          >
            <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-purple-400/90">
              Security Protocol
            </span>
            <h3 className="mt-3 font-syne text-lg font-extrabold uppercase tracking-tight text-zinc-100 sm:text-xl">
              Haunted Liquidity Lock
            </h3>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
              Initial LP tokens are sent straight to the burn address — keys
              thrown into the abyss where no mortal dev can ever recover them.
              The liquidity is haunted forever, and that is exactly how the
              coven likes it.
            </p>
          </motion.article>
        </div>
      </div>
    </section>
  );
}
